import { render, staticRenderFns } from "./ResumoRepasseProfissional.vue?vue&type=template&id=fe5f241e&scoped=true"
import script from "./ResumoRepasseProfissional.vue?vue&type=script&lang=js"
export * from "./ResumoRepasseProfissional.vue?vue&type=script&lang=js"
import style0 from "./ResumoRepasseProfissional.vue?vue&type=style&index=0&id=fe5f241e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5f241e",
  null
  
)

export default component.exports